module.exports = "/images/vendor/desiigner-svg/svg/logoipsum/logoipsum-16.svg?ca215eb6518f067037440db041b1d059";